import React from 'react';
import CustomField from '@components/CustomFields/CustomField';
import { Col, Row } from '@components/Grid';

const CustomFields = ({ customFields, ...formikProps }) => {
    const { values, touched, errors } = formikProps;

    return (
        customFields?.map(field => (
            <Row key={field?._id}>
                <Col xs={12} lg={9} xl={8}>
                    <CustomField
                        {...formikProps}
                        field={field}
                        name={`customFields.${field?.id}`}
                        value={values?.customFields?.[field?.id]}
                        error={
                            touched?.customFields?.[field?.id] && errors?.customFields?.[field?.id]
                        }
                    />
                </Col>
            </Row>
        )) ?? null
    );
};

export default CustomFields;
